




import { Component, Prop, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-chartjs';
import { ChartData, ChartOptions, Chart } from 'chart.js';
import Mixin from '@/mixin';

@Component({
  name: 'v-chart',
  mixins: [mixins.reactiveProp]
})
export default class VChart extends Mixin {
  @Prop({ required: true, default: null }) chartData?: ChartData;
  @Prop({ required: true, default: null }) options?: ChartOptions;
  public chart: Chart | null = null;

  createChart(chartData: ChartData, chartOptions: ChartOptions) {
    const canvas = this.$el as HTMLCanvasElement;
    const options = {
      type: 'horizontalBar',
      data: chartData,
      options: chartOptions
    };
    if (canvas) {
      this.chart = new Chart(canvas, options);
    }
  }

  @Watch('chartData', { immediate: true, deep: false })
  public updateChartData() {
    if (
      this.chartData &&
      this.chartData.datasets &&
      this.chartData.datasets[0].data &&
      this.options
    ) {
      if (this.chart) (this.chart as Chart).destroy();
      this.createChart(this.chartData, this.options);
    }
  }

  mounted() {
    this.updateChartData();
  }
}
